import { SlideFrame, SlideHeader, Reveal } from "@/components/presentation/slides/SlideFrame";
import { MediaPlaceholder } from "@/components/primitives/MediaPlaceholder";
import { Timeline } from "@/components/primitives/Timeline";

/**
 * 11 · FounderSlide
 *
 * Portrait + timeline + narrative. The portrait sits compact on the left;
 * the timeline of formative moments runs on the right; the supporting
 * narrative reads beneath the portrait so the founder's voice carries the
 * top of the frame.
 *
 * As with every slide, the portrait is intentionally a placeholder so
 * future iterations can swap in real photography without changing the
 * layout.
 */
const DEFAULT_MILESTONES = [
  { id: "m1", date: "Earlier",      title: "Formative experience",     body: "Placeholder copy." },
  { id: "m2", date: "Question",     title: "The insight moment",       body: "Placeholder copy.", active: true },
  { id: "m3", date: "Listening",    title: "Conversations with users", body: "Placeholder copy." },
  { id: "m4", date: "Today",        title: "Founding HAEVN",           body: "Placeholder copy." },
];

export const FounderSlide = ({
  eyebrow = "The Founder",
  title = "Why this team, and why now.",
  narrative = "One paragraph about the founder's posture and motive. The portrait and timeline support — never compete with — the words.",
  portraitLabel = "Founder portrait",
  milestones = DEFAULT_MILESTONES,
}) => {
  return (
    <SlideFrame testId="slide-founder">
      <SlideHeader eyebrow={eyebrow} title={title} />
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="flex flex-col gap-6 lg:col-span-5">
          <Reveal delay={2}>
            <MediaPlaceholder
              kind="image"
              label={portraitLabel}
              ratio="4/5"
              testId="founder-portrait"
              className="mx-auto max-w-sm"
            />
          </Reveal>
          {narrative && (
            <Reveal delay={3}>
              <p
                data-testid="founder-narrative"
                className="max-w-md text-base leading-relaxed text-muted-foreground"
              >
                {narrative}
              </p>
            </Reveal>
          )}
        </div>
        <Reveal delay={4} className="lg:col-span-7">
          <div data-testid="founder-timeline">
            <Timeline items={milestones} />
          </div>
        </Reveal>
      </div>
    </SlideFrame>
  );
};

export default FounderSlide;
